module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.title || _vm.rightText) ? _c('div', {
    staticClass: "m-blockheader"
  }, [_c('div', {
    staticClass: "m-blockheader--row"
  }, [(_vm.title) ? _c('div', {
    staticClass: "m-blockheader--row__title"
  }, [(_vm.faIconClass) ? _c('i', {
    class: _vm.faIconClass,
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.title) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.rightText) ? _c('div', {
    staticClass: "m-blockheader--row__description"
  }, [_vm._v(_vm._s(_vm.rightText))]) : _vm._e()]), _vm._v(" "), _c('hr')]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c84c6bca","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/checkout/components/molecules/BlockHeader.vue
// module id = 545
// module chunks = 2